export default __webpack_public_path__ + "static/media/recent_activity_1.9120b191.jpg";